import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import AdminLogin from "@/pages/AdminLogin";
import AdminProposals from "@/pages/AdminProposals";
import AdminProposalEditor from "@/pages/AdminProposalEditor";
import AdminContent from "@/pages/AdminContent";
import AdminContentEditor from "@/pages/AdminContentEditor";
import AdminSettings from "@/pages/AdminSettings";
import PublicProposal from "@/pages/PublicProposal";
import PublicContent from "@/pages/PublicContent";
import PublicContentIndex from "@/pages/PublicContentIndex";
import DestinationsHub from "@/pages/DestinationsHub";
import CarnetsLibrary from "@/pages/CarnetsLibrary";
import { AuthProvider, ProtectedRoute } from "@/lib/auth";

// Clean, SEO-friendly public URL prefixes → content type
const CONTENT_ROUTES = {
  destinations: "destination",
  guides: "guide",
  faq: "faq",
  "voyages-de-noces": "honeymoon",
  "voyages-sur-mesure": "sur_mesure",
  circuits: "circuit",
  hotels: "hotel",
  inspirations: "inspiration",
  pays: "pays",
  regions: "region",
  villes: "ville",
  conseils: "conseils",
  blog: "blog",
};

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/devis/:slug" element={<PublicProposal />} />
              <Route path="/carnets" element={<CarnetsLibrary />} />
              <Route path="/carnets/:slug" element={<PublicProposal source="carnet" />} />
              {Object.entries(CONTENT_ROUTES).map(([prefix, type]) => (
                <Route key={prefix} path={`/${prefix}/:slug`} element={<PublicContent contentType={type} />} />
              ))}
              <Route path="/destinations" element={<DestinationsHub />} />
              {Object.entries(CONTENT_ROUTES).filter(([prefix]) => prefix !== "destinations").map(([prefix, type]) => (
                <Route key={`idx-${prefix}`} path={`/${prefix}`} element={<PublicContentIndex contentType={type} />} />
              ))}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
              <Route path="/admin/proposals" element={<ProtectedRoute><AdminProposals /></ProtectedRoute>} />
              <Route path="/admin/proposals/:id" element={<ProtectedRoute><AdminProposalEditor /></ProtectedRoute>} />
              <Route path="/admin/content" element={<ProtectedRoute><AdminContent /></ProtectedRoute>} />
              <Route path="/admin/content/:id" element={<ProtectedRoute><AdminContentEditor /></ProtectedRoute>} />
              <Route path="/admin/settings" element={<ProtectedRoute><AdminSettings /></ProtectedRoute>} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;
